export default {"src":"/_next/static/media/icon-level-8.adb08d09.svg","height":25,"width":52};